import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import PopularGrid from './components/PopularGrid';
import CategoryRankSection from './components/CategoryRankSection';
import FeaturesSection from './components/FeaturesSection';
import TestimonialSection from './components/TestimonialSection';
import CTASection from './components/CTASection';
import FAQSection from './components/FAQSection';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <PopularGrid />
        <CategoryRankSection />
        <FeaturesSection />
        <TestimonialSection />
        <CTASection />
        <FAQSection />
      </main>
      <Footer />

      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "WebPage",
          "name": "韩漫免费-漫画在线观看下拉式-好看的韩国漫画大全-韩漫网站",
          "description": "韩漫免费,漫画在线观看,下拉式,韩国漫画大全,韩漫网站 - 作为韩漫爱好者，您可以在韩漫网站免费观看下拉式韩国漫画大全，在线浏览各种热门作品，轻松又愉快。",
          "url": "http://bestyoungman.com/",
          "isPartOf": {
            "@type": "WebSite",
            "name": "韩漫网站",
            "url": "http://bestyoungman.com/"
          },
          "breadcrumb": {
            "@type": "BreadcrumbList",
            "itemListElement": [
              {
                "@type": "ListItem",
                "position": 1,
                "name": "首页",
                "item": "http://bestyoungman.com/"
              }
            ]
          }
        })}
      </script>

      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          "mainEntity": [
            {
              "@type": "Question",
              "name": "韩漫网站的漫画都是免费观看的吗？",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "是的！韩漫网站上的所有韩国漫画作品均提供免费在线观看服务。我们致力于为韩漫爱好者打造一个高质量的免费阅读平台，无需付费即可畅读所有热门连载和完结作品。"
              }
            },
            {
              "@type": "Question",
              "name": "什么是下拉式阅读体验？",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "下拉式阅读是专为手机和网页端优化的漫画阅读方式。与传统的翻页模式不同，您只需向下滑动屏幕即可连续阅读整话内容，画面切换流畅自然，无需等待加载，带来沉浸式的阅读享受。"
              }
            },
            {
              "@type": "Question",
              "name": "网站多久更新一次漫画内容？",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "我们每日同步更新热门连载漫画的最新章节，确保读者能够第一时间看到心仪作品的新内容。同时也会定期上架新作品，丰富漫画库的种类和数量。"
              }
            },
            {
              "@type": "Question",
              "name": "可以在手机上观看吗？",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "当然可以！韩漫网站完美适配手机、平板和电脑端。无论您使用什么设备，都能享受到流畅的下拉式阅读体验。只需打开浏览器访问我们的网站即可，无需下载任何APP。"
              }
            },
            {
              "@type": "Question",
              "name": "漫画的画质怎么样？",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "我们平台上的所有漫画均提供高清画质，色彩还原准确，细节清晰可见。每一话都经过精心优化，确保在不同设备上都能呈现最佳的视觉效果。"
              }
            }
          ]
        })}
      </script>
    </>
  );
}